import { css } from 'styled-components'
import { color, screen } from 'theme/mixins'

const buttonStyles = css`
	.amplify-button {
		height: 48px;

		&--primary {
			background: ${color('primary')};

			&:hover {
				background: ${color(['primary', '300'])};
			}
		}

		&--loading {
			color: ${color('white')};

			&:hover {
				color: ${color('white')};
			}
		}

		&--link {
			color: ${color('primary')};

			&:hover {
				background: transparent;
			}
		}
	}
`

const inputStyles = css`
	.amplify-input {
		border-radius: 6px;
		border: 1px solid #d9d9d9;
		padding: 10.4px 15px;
		line-height: 1.5715;

		&:focus,
		&:active {
			border: 1px solid ${color('primary')};
			box-shadow: none;
		}
	}

	.amplify-field {
		&__show-password {
			border: 1px solid #d9d9d9;
			border-left: none;

			&:hover {
				background: transparent;
				border-color: ${color('primary')};
			}
		}
	}

	.amplify-field-group {
		&__field-wrapper {
			&:has(> .amplify-input:focus) {
				& + div .amplify-field__show-password {
					border-color: ${color('primary')};
				}
			}
		}
	}
`

const tabStyles = css`
	.amplify-tabs-item {
		color: ${color('primary')};
		&[data-state='active'] {
			border-color: ${color('primary')};
		}
	}
`

const layoutStyles = css`
	[data-amplify-authenticator] [data-amplify-router] {
		border: 1px solid #f0f0f0;
		box-shadow: none;
		border-radius: 6px;
	}

	${screen.lte.xs`
		[data-amplify-authenticator] [data-amplify-container] {
			width: 100%;
		}
	`}
`

export default css`
	${buttonStyles}
	${inputStyles}
  ${tabStyles}
  ${layoutStyles}
`
